// Discord's message limit (Sierra's copyDiscord and splitDiscord, line 870), for
// every module's "Copy for Discord": text over 2,000 characters is copied in parts.

/** The most characters one Discord message holds. */
export const DISCORD_MESSAGE_LIMIT = 2000;

/** The most characters in a part of a split message, leaving room as Sierra does. */
export const DISCORD_PART_LIMIT = 1990;

/**
 * Text of 2,000 characters or fewer is one part. Longer text splits at line breaks
 * into parts of at most 1,990 characters; a single line longer than that is cut.
 */
export function splitDiscord(text: string): string[] {
  if (text.length <= DISCORD_MESSAGE_LIMIT) return [text];
  const parts: string[] = [];
  let current = '';
  for (const whole of text.split('\n')) {
    let line = whole;
    while (line.length > DISCORD_PART_LIMIT) {
      if (current !== '') {
        parts.push(current);
        current = '';
      }
      parts.push(line.slice(0, DISCORD_PART_LIMIT));
      line = line.slice(DISCORD_PART_LIMIT);
    }
    if ((current === '' ? 0 : current.length + 1) + line.length > DISCORD_PART_LIMIT) {
      parts.push(current);
      current = line;
    } else {
      current = current === '' ? line : `${current}\n${line}`;
    }
  }
  if (current !== '') parts.push(current);
  return parts;
}
